import HttpRequest from '../../../httpRequest'
import Vue from 'vue'
import AppConstant from '../constants/AppConstant'

class AxiosService extends HttpRequest {
  doGet(path) {
    return new Promise((resolve, reject) => {
      this.get(path, {}).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        this.handleErr(err)
        reject(err)
      }).finally(() => {

      })
    })
  }

  doPost(path, data) {
    return new Promise((resolve, reject) => {
      this.post(path, data).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        this.handleErr(err)
        reject(err)
      }).finally(() => {
      })
    })
  }

  doPut(path, data) {
    return new Promise((resolve, reject) => {
      this.put(path, data).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        this.handleErr(err)
        reject(err)
      })
    })
  }

  doDelete(path) {
    return new Promise((resolve, reject) => {
      this.delete(path).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        this.handleErr(err)
        reject(err)
      })
    })
  }

  doPostFormData(path, data) {
    return new Promise((resolve, reject) => {
      this.post(path, data).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        this.handleErr(err)
        reject(err)
      })
    })
  }

  doPutFormData(path, data) {
    return new Promise((resolve) => {
      this.put(path, data).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        this.handleErr(err)
      })
    })
  }

  handleErr(err) {    
    if(!err.response) {
      Vue.notify({
        group: "foo",
        type: "error",
        title: "<span style='font-size:18px'>เกิดข้อผิดพลาด</span>",
        text: "<span style='font-size:15px'>กรุณาติดต่อผู้ดูแลระบบ</span>",
        duration: 6000,
      });      
    }
    if (err.response.status === 400) {
      Vue.notify({
        group: 'foo',
        type: 'warn',
        title: "<span style='font-size:18px'>แจ้งเตือน</span>",
        text: `<span style='font-size:15px'> ${err.response.data.message || 'กรุณาติดต่อผู้ดูแลระบบ'}</span>`,                
        duration: 10000
      })
    } else if (err.response.status === 401) {
      localStorage.removeItem(AppConstant.APP_TOKEN)
      window.location.href = '/#/login'
    } else if (err.response.status === 403) {      
      Vue.notify({
        group: 'foo',
        type: 'warn',
        title: "<span style='font-size:18px'>CODE: 403</span>",
        text: `<span style='font-size:15px'> ${err.response.data.message || 'กรุณาติดต่อผู้ดูแลระบบ'}</span>`,
        duration: 10000
      })
    } else {      
      Vue.notify({
        group: 'foo',
        type: 'error',
        title: "<span style='font-size:18px'>ทำรายการไม่สำเร็จ</span>",
        text: `<span style='font-size:15px'> ${err.response.data.message || 'กรุณาติดต่อผู้ดูแลระบบ'}</span>`,
        duration: 10000
      })
    }
  }
}

export default AxiosService
